import cn from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { ConditionCode } from '@/shared/api/protocol-ts/model/dto_report_condition_codes_pb';
import { Condition } from '@/shared/api/protocol-ts/model/dto_report_condition_pb';
import { ViewMIR } from '@/shared/graphics/medicalImageRender/MedicalImageRender';
import { useMedia } from '@/shared/hooks';

import { conditionModel } from '@/entities/condition';
import { conditionText } from '@/entities/condition/config/i18n';

import styles from './RarePathologies.module.scss';

type NonDentalFindingsProps = {
  conditionsGrouped: Record<ConditionCode, Condition[]>;
  className?: string;
  isPreviewMode?: boolean;
};

export const RarePathologies: FC<NonDentalFindingsProps> = (props) => {
  const { className, conditionsGrouped, isPreviewMode = false } = props;

  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const { isMobile } = useMedia();

  const handleConditionHover = (conditionIDs: string[]) => {
    if (!isPreviewMode) {
      dispatch(
        conditionModel.actions.setHoveredNonDentalConditionIDs(conditionIDs),
      );
    }
  };

  const conditionsArray = Object.entries(conditionsGrouped);

  return (
    <div className={cn(styles.container, className)}>
      <div className={styles.conditions}>
        {conditionsArray.map(([code, conditions], index) => {
          const isLastCondition = index === conditionsArray.length - 1;
          const firstCondition = conditions[0];
          const conditionIDs = conditions.map((condition) => condition.ID);

          return (
            <p
              key={code + firstCondition.ID}
              className={cn(
                isMobile ? 'p2m' : 'p2',
                isPreviewMode && 'blackText',
                !isPreviewMode && styles.isInteractive,
              )}
              onMouseEnter={() => handleConditionHover(conditionIDs)}
              onMouseLeave={() => handleConditionHover([])}
            >
              {formatMessage(conditionText[firstCondition.Code])}
              {conditions.length > 1 && ` (${conditions.length})`}

              {isPreviewMode && !isLastCondition && `, `}
            </p>
          );
        })}
      </div>
      <div
        data-component="none-dental-findings-view"
        style={{ display: 'contents' }}
      >
        <ViewMIR viewName="noneDentalFindings" className={styles.viewMIR} />
      </div>
    </div>
  );
};
